
<nav role="navigation" class="filters">
  <form>
    <input
      #filtersReset
      style="margin-bottom: 25px;"
      name="filtersReset"
      aria-label="filters Reset"
      type="button"
      value="{{ 'reset_filter' | translate }}"
      class="screen-lg-xl reset-filter cta-link-regular 26-pfc"
      [class.reset-filter-disabled]="disableReset"
      (click)="resetFilters($event)"
    />
    <ul class="filter-list">
      <fieldset
        tabindex="0"
        id="{{ filterItem.filterField }}"
        [ngClass]="{ md: screenWidth === 'MD', sm: screenWidth === 'SM' }"
        class="filter-item medium-6 small-12"
        *ngFor="
          let filterItem of productFilter;
          let filterItemIndex = index
        "
      >
        <div
          *ngIf="
            filterItem.displayName !== 'price' ||
            filterItem.defaultMinRangeVal !== filterItem.defaultMaxRangeVal
          "
        >
          <legend class="filter-title">
            {{ filterItem.displayName | lowercase | translate }}
          </legend>
          <div *ngIf="filterItem.fieldType === 'checkbox'">
            <div class="filter-content">
              <ul class="filter-values">
                <li
                  class="filter-value"
                  *ngFor="
                    let values of filterItem?.filterValues
                      | slice
                        : 0
                        : getMaxToShow(
                            filterItemIndex,
                            filterItem?.filterValues
                          );
                    let i = index
                  "
                >
                  <div class="c-checkbox c-checkbox--normal">
                    <input
                      class="sr-only"
                      type="checkbox"
                      id="{{ filterItem.filterField }}-{{ i }}"
                      name="{{ filterItem.filterField }}-{{ i }}"
                      (change)="
                        changed(
                          filterItem,
                          values,
                          $event.currentTarget.checked
                        )
                      "
                      [value]="values.checked"
                      [checked]="values.checked"
                    />
                    <label
                      class="c-checkbox__label"
                      for="{{ filterItem.filterField }}-{{ i }}"
                    >
                      <span
                        *ngIf="
                          filterItem.filterField !==
                            'customer_rating_filter' &&
                          filterItem.dataType !== 'Boolean' &&
                          filterItem.displayName !== 'category'
                        "
                        >{{ values.dispValue | translate }}</span
                      >
                      <span
                        *ngIf="
                          filterItem.filterField !==
                            'customer_rating_filter' &&
                          filterItem.dataType !== 'Boolean' &&
                          filterItem.displayName === 'category'
                        "
                        >{{
                          filterItem.displayName + "_" + values.dispValue
                            | lowercase
                            | translate
                        }}</span
                      >
                      <span
                        *ngIf="
                          filterItem.filterField !==
                            'customer_rating_filter' &&
                          filterItem.dataType === 'Boolean'
                        "
                        >{{ values.dispValueDesription | translate }}</span
                      >
                      <rating-generator
                        *ngIf="
                          filterItem.filterField ===
                          'customer_rating_filter'
                        "
                        [points]="values.dispValue"
                      ></rating-generator>
                      <!-- <span *ngIf="filterItem.showCount  && filterItem.displayName !== 'category'" class="float-right">({{values.units}})</span> -->
                    </label>
                    <span
                      *ngIf="
                        filterItem.showCount &&
                        filterItem.displayName !== 'category'
                      "
                      class="float-right"
                      >({{ values.units }})</span
                    >
                  </div>
                  <button
                    *ngIf="
                      i === getMaxToShow(filterItemIndex) - 1 &&
                      filterItem.filterValues?.length > maxToShow
                    "
                    [class.show-more-content]="
                      showMore(filterItemIndex, filterItem?.filterValues)
                    "
                    [class.show-less-content]="
                      !showMore(filterItemIndex, filterItem?.filterValues)
                    "
                    (click)="
                      toggleShowMoreLess(
                        filterItemIndex,
                        filterItem.filterValues?.length
                      )
                    "
                  >
                    <span class="title">{{
                      getShowMoreLessLabel(filterItemIndex) | translate
                    }}</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div *ngIf="filterItem.fieldType === 'range'">
            <div class="filter-content">
              <range-slider
                [screenWidth]="screenWidth"
                [rangeSliderInput]="filterItem"
                (filterRangeInputChange)="changed(type, range, $event)"
              ></range-slider>
            </div>
          </div>
        </div>
      </fieldset>
    </ul>
  </form>
</nav>